// Libraries
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
// Data
import { modalActions } from './useModalStore.actions';
import { initialState } from './useModalStore.state';
// Types
import { ModalStore } from './useModalStore.types';

/**
 * Creates and configures the Modal states.
 */
export const useModalStore = create(
  immer<ModalStore>((set) => ({
    ...initialState,
    ...modalActions(set),
  }))
);
